module.exports = __webpack_public_path__ + "static/img/renwu.f1f9b58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/index/renwu.png
// module id = EPAI
// module chunks = 0